import React from 'react';
import cx from 'classnames';
import { bool, string, node } from 'prop-types';
import statusShape from 'propTypes/segmentStatus';

import styles from './tooltip-item.scss';

export default function TooltipItem({ label, children, status, isLocation }) {
  return (
    <li
      className={cx(styles.main, {
        [styles[`status-${status}`]]: status,
        [styles.isLocation]: isLocation,
      })}
      key={label}
    >
      <div className={styles.label}>
        {label}
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </li>
  );
}

TooltipItem.propTypes = {
  label: string.isRequired,
  children: node.isRequired,
  status: statusShape,
  isLocation: bool,
};



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/TooltipItem/index.js